<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptertitle"><a id="p1"></a> 1</h1>
<p class="left"><em>6 April</em> Bought the black hinny Mule today, $18, also the spavint gray as my money is so short and I have hope he will put on wt, his eyes are clear w a smart look in them and his feet not tender. Believe I am now outfitted, shall start out at Day Break. Weather is poor w rain &amp; a cold wind, not a favorable day for travel but I shall not put it off, each days boarding $3 I can ill afford and now the stables cost of 2 Mules &amp; the Goats. My list of needs has many unhappy lines drawn through marking out this or that not so nec at prices so very dear. O well the poor Mules will be hard put to carry the things as is. I have stld my accts w Mrs Mailer as I plan to be gone in the morning before she is about. She has given me a good rolling pin from her own kitchen as well as many candle stubs &amp; ends of wax, tho not in other ways been over kind these few days I have boarded. I believe she thinks I am a Mad Woman or worse. For myself, after so long in getting to this day, I find I am not much afraid—but in that may be some proof of my Madness. I shall not see Mrs Mailer nor perhaps any woman, at least until the Fall if I am still alive then and able to come out for my Winter’s nec. But I am used to being Alone, in spirit if not in body, and shall <em>not</em> be Lonely, as I never have been inclined that way. I believe what I feel is just a keenness to get to that place and stand under my own roof at last.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c01.vue?3a0ef335